import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import TelegramWebApp from './telegram-init';
import ErrorBoundary from './components/ErrorBoundary';
import { UserStoreProvider } from './stores/UserStore';
import { ReferralStoreProvider } from './stores/ReferralStore';

// Список ошибок, которые должны вести на страницу ошибки
const CRITICAL_ERRORS = [
  'NetworkError', // Ошибки сети
  'DockerError',  // Ошибки Docker
  'ServiceUnavailable', // Сервис недоступен
  'DatabaseError', // Ошибки базы данных
];

export const App: React.FC = () => {
  const initRef = React.useRef(false);

  React.useEffect(() => {
    const initApp = async () => {
      if (!initRef.current) {
        await TelegramWebApp.init();
        initRef.current = true;
      }
    };

    initApp();
  }, []);

  const handleError = (error: Error) => {
    // Здесь можно добавить логику для отправки ошибок в систему аналитики
    console.error('Global error handler:', error);
  };

  return (
    <ErrorBoundary 
      redirectErrors={CRITICAL_ERRORS}
      onError={handleError}
    >
      <UserStoreProvider>
        <ReferralStoreProvider>
          <RouterProvider router={router} />
        </ReferralStoreProvider>
      </UserStoreProvider>
    </ErrorBoundary>
  );
};
